// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".side-bar-cheapest-deliveries{display:flex;justify-content:space-between}.side-bar-cheapest-deliveries__tooltip-button{margin-left:4px}", ""]);
// Exports
module.exports = exports;
